module.exports = __webpack_public_path__ + "static/media/myphoto4.7b4f202f.JPG";